import NewMainLayout from "@features/layout/newMain/NewMainLayout";

export const MainPage = () => {
  return <NewMainLayout />;
};
